import { render, staticRenderFns } from "./footers.vue?vue&type=template&id=0a99eab4&scoped=true"
import script from "./footers.vue?vue&type=script&lang=js"
export * from "./footers.vue?vue&type=script&lang=js"
import style0 from "./footers.vue?vue&type=style&index=0&id=0a99eab4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a99eab4",
  null
  
)

export default component.exports